import { createProvider } from '@/vue-apollo'

const apolloProvider = createProvider();
const apollo = apolloProvider.defaultClient;

export { apolloProvider, apollo };
